import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Navbar from '../navbar/Navbar'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Button from '@material-ui/core/Button';
import Footer from '../footer/footer'
import { Link } from "react-router-dom";


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

export default function ControlledExpansionPanels() {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    return (
        <div className={classes.root}>
            <Navbar />
            <Link id='back' to="/QuestionBank">
                <Button style={{ margin: '10px', marginTop: '70px' }} variant="contained" color="primary" href="#contained-buttons">
                    <KeyboardBackspaceIcon />
                </Button>
            </Link>
            <h1 id='desc' style={{ textAlign: 'center' }}>Sixth sem CSE/ISE QB</h1>


            <ExpansionPanel expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ marginTop: '40px' }}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography className={classes.heading}>CNS</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}>Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Question Bank <br/>
                            <a href="https://drive.google.com/file/d/1c9ZgUtqyQhZgPMkwycKTIb8tC1KJEVxI/view?usp=sharing">Module 1</a> <br/>
                            <a href="https://drive.google.com/file/d/1i39seGinqiu-InvnfkoeEAkUZteNbqK1/view?usp=sharing">Module 2</a><br/>
                            <a href="https://drive.google.com/file/d/1ZPoGj3Jl1VqAUfr54d4N74qmBJyhb6-3/view?usp=sharing">Module 3</a><br/>
                            <a href="https://drive.google.com/file/d/1yu7CFnsUF8OGvAQ0JU-ofXpYQUpMA8kz/view?usp=sharing">Module 4</a><br/>
                            <a href="https://drive.google.com/file/d/1NGHifwSac5bVPhw6j-EYMM_zFyrrdyW_/view?usp=sharing">Module 5</a>
                        </div>
                    </Typography>
                    <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/166t61Puv0HmqaDcYPuI5qTpldkI0lkFm/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1BdzOiJ68dvlTvoD_RkhOCsFmchTRMreu/view?usp=sharing">
                July 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1dcmq77bNBhVOvx3UEgZvsJa07GG9-7C2/view?usp=sharing">
                July 2018
              </a>
              <br />
              
              </div>
              </Typography>
                
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography className={classes.heading}>CG</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Question Bank <br/>
                            <a href="https://drive.google.com/file/d/13jH6n3tqJBmHtq_SNG9tKLQHK6tkzyLU/view?usp=sharing">Module 1</a> <br/>
                            <a href="https://drive.google.com/file/d/19QbeoYGolobmFUb1_AIpnKII9LPjllJY/view?usp=sharing">Module 2</a><br/>
                            <a href="https://drive.google.com/file/d/13Cxdp2xhTt7kwefptqfRUyq7QGizmFTv/view?usp=sharing">Module 3</a><br/>
                            <a href="https://drive.google.com/file/d/1wMItWMzBORiWPQxrvMHrtFvDhPcB_TiV/view?usp=sharing">Module 4</a><br/>
                            <a href="https://drive.google.com/file/d/1hFMbx69pL7eTP0w0MGt7uFz6QP3Af1jm/view?usp=sharing">Module 5</a>
                        </div>
                    </Typography>
                    <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/19HyZZ6CFP40qmVPj71OQ5TivU1WAshox/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1iGaMRUHlrca866ueorcHXjFk23Jv1zuC/view?usp=sharing">
                July 2019
              </a>
              <br />
    
              
              </div>
              </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography className={classes.heading}>OS</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}>Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Question Bank <br/>
                            <a href="https://drive.google.com/file/d/1WYY3Ec2r3nE0CvEMUjSONAl6NY9-d-v_/view?usp=sharing">Module 1</a> <br/>
                            <a href="https://drive.google.com/file/d/1K3zoZRbGoBbkhjPy-CqOrITGRbeijIlx/view?usp=sharing">Module2</a><br/>
                            <a href="https://drive.google.com/file/d/13sFi9o2FOwbxdqvESEgf9SEP7XvML2JS/view?usp=sharing">Module 3</a><br/>
                            <a href="https://drive.google.com/file/d/1g-m1NTl3LVp9DkWKUFBLg7Art5en53-6/view?usp=sharing">Module 4</a><br/>
                            <a href="https://drive.google.com/file/d/1O4bMVIL7w3NlxvyJwRetE58_Ir1-_U8I/view?usp=sharing">Module 5</a>
                        </div>
                    </Typography>
                    <Typography style={{marginLeft:'30px'}}>
                        <div style={{ color: 'black' }}>
                            Previous year Question Papers <br/>

                            <a href="https://drive.google.com/file/d/12uZ2DX2RdX0Xf3L0zS-LDfR-WqzM3y_K/view?usp=sharing">Jan 2019</a> <br/>
                            <a href="https://drive.google.com/file/d/1QJESU8FoKjCYtpopocnroAkiKglE_sP9/view?usp=sharing">July 2019</a><br/>
                           
                        </div>
                    </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>OR</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Question Bank <br/>
                            <a href="https://drive.google.com/file/d/1YabB6jLz0io9wpSOwSucr3TL83JbG9ZX/view?usp=sharing">Module 1</a> <br/>
                            <a href="https://drive.google.com/file/d/15QhdthT1eN-MWQ4KIzCq1OTDdtUo67GO/view?usp=sharing">Module 2</a><br/>
                            <a href="https://drive.google.com/file/d/18xzbf0lkvcisfN6dKN3EnWAUvDSVLksv/view?usp=sharing">Module 3</a><br/>
                            <a href="https://drive.google.com/file/d/1kuFiNm2YIuZdDR4JhC8NUaA6hHXrsvSg/view?usp=sharing">Module 4</a><br/>
                            <a href="https://drive.google.com/file/d/10w6gznUCvmi8IQbUx4Xv5uohqQJ2AF6L/view?usp=sharing">Module 5</a>
                        </div>
                    </Typography>
                    <Typography style={{marginLeft:'30px'}}>
                        <div style={{ color: 'black' }}>
                            Previous year Question Papers <br/>

                            <a href="https://drive.google.com/file/d/1pmLk10n2AoMghnwQgR3f5CSKcWGK3KFe/view?usp=sharing">Jan 2019</a> <br/>
                            <a href="https://drive.google.com/file/d/1ICGH00eD6AbfppovnYjKkyN1qRLhAfHh/view?usp=sharing">July 2019</a><br/>
                           
                        </div>
                        </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>Python</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Question bank <br/>
                            <a href="https://drive.google.com/file/d/1hOhCmz4d6uSbDpPyjzrHkFyMWeDeujkv/view?usp=sharing"target="_blank">Module 1</a> <br/>
                        <a href="https://drive.google.com/file/d/1B3pBpzcX_f_QC79NHGrL8TOFS05FF4lg/view?usp=sharing"target="_blank">Module 2</a><br/>
                        <a href="https://drive.google.com/file/d/1BhdIUnNkCvoFx1eDuIb2On_cmjXwrZDa/view?usp=sharing"target="_blank">Module 3</a><br/>
                        <a href="https://drive.google.com/file/d/1EqBH7r9WKQguGxlCn0_NVPq59-EB204W/view?usp=sharing"target="_blank">Module 4</a><br/>
                        <a href="https://drive.google.com/file/d/1I7H6bQ_Gd5s2QhJLem5_Vx52rbKn_PIB/view?usp=sharing"target="_blank">Module 5</a>
                        </div>
                    </Typography>
                    <Typography style={{marginLeft:'30px'}}>
                        <div style={{ color: 'black' }}>
                            Previous year Question Papers <br/>

                            <a href="https://drive.google.com/file/d/13Mkg1J3jtBYGoe_Haibj2zucPidvdnFx/view?usp=sharing">Jan 2019</a> <br/>
                            <a href="https://drive.google.com/file/d/1fpacq-LRnCZrQoePdZmjhbPHrEowhIGR/view?usp=sharing">July 2019</a><br/>
                           
                        </div>
                        </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>SS & CD</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}>Not Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Previous year Question Paper <br/>
                        <a href="https://drive.google.com/file/d/12yPFWgC_gGW8U_MBluSsi4f45vL_ruou/view?usp=sharing">Jan 2019</a> <br/>
                            <a href="https://drive.google.com/file/d/1R0FSpYqtwv_lLC8gX5UWe47t33-Wybam/view?usp=sharing">July 2019</a><br/>
                           
                            
                        </div>
                    </Typography>
                   

                </ExpansionPanelDetails>
            </ExpansionPanel>
           
            <Footer />


        </div>
    );
}
